import GrowthLimitsComponent from '../Components/Growth/GrowthLimitsComponent';

function GrowthLimitsPage() {
  return <GrowthLimitsComponent />;
}

export default GrowthLimitsPage;